import { render, staticRenderFns } from "./HistoryToDialog.vue?vue&type=template&id=06924e9c&scoped=true"
import script from "./HistoryToDialog.vue?vue&type=script&lang=js"
export * from "./HistoryToDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryToDialog.vue?vue&type=style&index=0&id=06924e9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06924e9c",
  null
  
)

export default component.exports